import Component from './component'
import withTranslation from '../../globals/components/withTranslation'
import { IReregistrationModalProps } from './types'

export default withTranslation(Component) as React.ComponentClass<IReregistrationModalProps>
